Vue.component("RefillReassurance", {
    props: {
        icons: {
            type: Array,
            required: true
        },
        labels: {
            type: Array,
            required: true
        },
    },
    template: `
        <div>
        <div class="alert-container additional-message">
            <ul class="items-list row my-0">
                <li v-for="(label, index) in labels" class="col-12">
                    <div class="items-list-item">
                        <span class="item-icon" :class="icons[index]" aria-hidden="true"></span>
                        <div class="item-container no-border-bottom">
                            <div class="item-text">
                                <span>{{ label }}</span>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        </div>
    `
});
